<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19.31 5.55l-4.56-1.5a1 1 0 00-.6 0l-4.64 1.4-4.19-1.4A1 1 0 004 5v12.5a1 1 0 00.68.95L9.18 20a1.06 1.06 0 00.61 0l4.69-1.41 4.2 1.4A1 1 0 0020 19V6.5a1 1 0 00-.69-.95zM10 7.39l4-1.21v10.43l-4 1.2zm-4-1l3 1v10.39l-3-1zm9 10.22V6.24l3 1v10.37z"/></svg>